import { isDefined } from "Utils/functions";
import { WindowSize } from "Utils/screenSizeUtils";

export const getWidth = (
  windowSize: WindowSize,
  defaultWidth: number,
  customWidth?: number,
): number => {
  if (isDefined(customWidth)) {
    return customWidth;
  }
  if (windowSize.width) {
    if (windowSize.width < 440) {
      return 220;
    } else if (windowSize.width < 540) {
      return 320;
    }
  }
  return defaultWidth;
};

export const getHeight = (
  defaultHeight: number,
  customHeight?: number,
): number => {
  return isDefined(customHeight) ? customHeight : defaultHeight;
};
